import React, { Component } from 'react';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import './QuestionTypePicker.css';

class QuestionTypePicker extends Component {
    handleSelect(eventKey) {
        this.props.setSelected(eventKey);
    }
    render() {
        let pickerId = this.props.title + "-picker";
        return (
            <DropdownButton className="question-type-picker" value={this.props.initialValue} title={this.props.title} id={pickerId}>
                <MenuItem header>{this.props.typeName}</MenuItem>
                {
                    this.props.questionTypes.map((item, i) => {
                        return (
                            <MenuItem
                                key={item.uuid}
                                eventKey={item}
                                onSelect={(e) => this.handleSelect(e)}>
                                {item.name}
                            </MenuItem>
                        );
                    })
                }
            </DropdownButton>
        )
    }
}

export default QuestionTypePicker;